import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "font-size-14-600 ellipsis" }
const _hoisted_2 = { class: "font-size-10-400 ellipsis" }
const _hoisted_3 = { class: "subtitle mt-2" }
const _hoisted_4 = { class: "d-flex justify-center mb-4" }

import {computed} from 'vue';
import CreatedBy from "@/components/custom/CreatedBy.vue";
import Icon from "@/components/Icons/Icon.vue";
import CardComponent from "@/components/custom/CardComponent.vue";
import {useRouter} from "vue-router";


export default /*@__PURE__*/_defineComponent({
  __name: 'MedicalAlertCard',
  props: {
  disableBtn: {
    type: Boolean,
    default: false,
  },
  dob: {
    type: String,
    default: '',
  },
  alert: {
    type: Object,
    default: () => {
      return {
        name: '',
        type: '',
        description: '',
        created_by: '',
      }
    },
  },
},
  setup(__props) {

const router = useRouter();

const props = __props

const isStatusEnded = computed(() => {
  return props.alert.status === 'Ended';
});

const setIcon = computed(() => {
  return props.alert?.type === 'Allergy' ? 'allergy-icon' : 'file-icon'
});

const setCreateByIcon = computed(() => {
  return props.alert.created_by === 'client' ? 'client-icon' : 'practitioner-icon'
});

const setColorIfStatusEnded = computed(() => {
  return isStatusEnded.value ? 'font-grey' : 'font-black'
});

const setButtonText = computed(() => {
  return props.alert.created_by === 'client' && props.alert.status === 'Ongoing' ? 'Edit' : 'View'
});

const handleMedicalAlertAction = () => {
  if (props.alert.created_by === 'client' && props.alert.status === 'Ongoing') {
    return router.push({
      name: 'create-edit-medical-alerts',
      params: {action: 'edit', id: props.alert.id},
      query: {dob: props.dob}
    });
  }

  return router.push({
    name: 'view-medical-alert',
    params: {id: props.alert.id},
    query: {dob: props.dob}
  });
};

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createBlock(CardComponent, null, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass([{'primary-color': !isStatusEnded.value, 'font-grey': isStatusEnded.value}, "text-center font-size-10-400"])
      }, [
        _createVNode(Icon, { icon: setIcon.value }, null, 8, ["icon"]),
        _createElementVNode("p", null, _toDisplayString(__props.alert.type), 1)
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass([setColorIfStatusEnded.value, "ml-2"])
      }, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_1, _toDisplayString(__props.alert.name), 1),
          _createElementVNode("p", _hoisted_2, _toDisplayString(__props.alert.description), 1)
        ]),
        _createElementVNode("p", _hoisted_3, [
          _renderSlot(_ctx.$slots, "default")
        ])
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass([setColorIfStatusEnded.value, "text-center"])
      }, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(CreatedBy, {
            color: isStatusEnded.value ? 'grey_light' : 'primaryColor',
            gap: setCreateByIcon.value === 'practitioner-icon'? '0': '4px',
            icon: setCreateByIcon.value
          }, null, 8, ["color", "gap", "icon"])
        ]),
        _createVNode(_component_v_btn, {
          class: _normalizeClass([{'white-btn': __props.alert.created_by !== 'client' || isStatusEnded.value, 'primary-button': !isStatusEnded.value}, "b-round-20 outline-btn"]),
          disabled: __props.disableBtn,
          elevation: "0",
          height: "32px",
          "x-small": "",
          onClick: handleMedicalAlertAction
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(setButtonText.value), 1)
          ]),
          _: 1
        }, 8, ["class", "disabled"])
      ], 2)
    ]),
    _: 3
  }))
}
}

})